// Index route — renders the knowledges list at exactly /knowledges.
// The parent file `knowledges.tsx` is now a layout-only Outlet so that
// child routes (knowledges.$knowledgeId, knowledges.$knowledgeId.edit)
// have a rendering slot. Without this split, navigating to a detail URL
// silently keeps the list visible because the child has no Outlet to
// mount into.
import { createFileRoute } from "@tanstack/react-router";
import KnowledgesPage from "@/features/knowledges/KnowledgesPage";

export const Route = createFileRoute("/_admin/knowledges/")({
  component: KnowledgesPage,
});
